'use strict';
class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.slider = this.querySelector('.swiper');
    this.nextBtn = this.querySelector('.swiper-button-next');
    this.prevBtn = this.querySelector('.swiper-button-prev');
    this.pagination = this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');

    this.handleResize = this.handleResize.bind(this);
    this.updateNavigationButtons = this.updateNavigationButtons.bind(this);
  }
  
  connectedCallback() {
    this.initSwiper();
    this.setupExternalNavigation();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  // updateNavigationButtons() {
  //   if (!this.swiper || this.swiper.params.loop) return;

  //   if (this.swiper.isBeginning && !this.swiper.isEnd) {
  //     this.nextBtn?.classList.remove('swiper-button-disabled');
  //     this.prevBtn?.classList.add('swiper-button-disabled');
  //   } else if (this.swiper.isEnd && !this.swiper.isBeginning) {
  //     this.prevBtn?.classList.remove('swiper-button-disabled');
  //     this.nextBtn?.classList.add('swiper-button-disabled');
  //   } else if (this.swiper.isEnd && this.swiper.isBeginning) {
  //     this.prevBtn?.classList.add('swiper-button-disabled');
  //     this.nextBtn?.classList.add('swiper-button-disabled');
  //   } else {
  //     this.prevBtn?.classList.remove('swiper-button-disabled');
  //     this.nextBtn?.classList.remove('swiper-button-disabled');
  //   }
  // }
  updateNavigationButtons() {
    if (!this.swiper || this.swiper.params.loop) return;
  
    const disablePrev = this.swiper.isBeginning || (this.swiper.isBeginning && this.swiper.isEnd);
    const disableNext = this.swiper.isEnd || (this.swiper.isBeginning && this.swiper.isEnd);
  
    // Update prev button
    if (this.prevBtn) {
      this.prevBtn.classList.toggle('swiper-button-disabled', disablePrev);
      this.prevBtn.toggleAttribute('disabled', disablePrev);
    }
  
    // Update next button
    if (this.nextBtn) {
      this.nextBtn.classList.toggle('swiper-button-disabled', disableNext);
      this.nextBtn.toggleAttribute('disabled', disableNext);
    }
  }
  
}

CustomSlider.prototype.initSwiper = function () {
  if (!this.slider) return;

  const {
    speed = "800",
    loop = "false",
    centeredSlides = "false",
    slidesCount = "1",
    slidesCountMobile = "1",
    spaceBetween = "20",
    spaceBetweenMobile = "20",
    mousewheel = "false",
    pagination = "false",
    scrollbar = "false",
    autoplay = "false",
    autoplayDelay = "3000",
    slidesOffsetBefore = "0",
    direction = "horizontal",
    directionMobile = "horizontal",
    initialSlide = "0"
  } = this.dataset;

  const slidesCountValue = slidesCount === "auto" ? "auto" : Number(slidesCount);
  const slidesCountMobileValue = slidesCountMobile === "auto" ? "auto" : Number(slidesCountMobile);
  const spaceBetweenValue = Number(spaceBetween);
  const spaceBetweenMobileValue = Number(spaceBetweenMobile);
  const speedValue = Number(speed);
  const autoplayDelayValue = Number(autoplayDelay) || 3000;
  const slidesOffsetBeforeValue = slidesOffsetBefore ? Number(slidesOffsetBefore) : 0;
  const isLoop = loop === "true";
  const isCentered = centeredSlides === "true";
  const isMousewheel = mousewheel === "true";
  const isPagination = pagination === "true";
  const isScrollbar = scrollbar === "true";
  const isAutoplay = autoplay === "true";
  const isDirection = direction === "horizontal" ? "horizontal" : "vertical";
  const isDirectionMobile = directionMobile === "horizontal" ? "horizontal" : "vertical";
  const initialSlideValue = initialSlide ? Number(initialSlide) : 0;
  const swiperOptions = {
    loop: isLoop,
    slidesPerView: slidesCountMobileValue,
    loopAdditionalSlides: 2,
    centeredSlides: isCentered,
    initialSlide: initialSlideValue,
    spaceBetween: spaceBetweenMobileValue, 
    grabCursor: true,
    speed: speedValue,
    // direction: isDirection,
    direction: isDirectionMobile,
    mousewheel: isMousewheel ? {
      forceToAxis: true,
      sensitivity: 0.5,
      thresholdDelta: 30,
      thresholdTime: 500,
    } : false,
    autoplay: isAutoplay ? {
      delay: autoplayDelayValue,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    } : false,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      750: {
        spaceBetween: spaceBetweenValue, 
        slidesPerView: slidesCountValue,
        centeredSlides: isCentered,
        slidesOffsetBefore: slidesOffsetBeforeValue || false,
        direction: isDirection,
      },
    },
    pagination: isPagination && this.pagination ? 
      {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) =>
          `<button class="slider-counter__link slider-counter__link--long_dots link ${className}">
            <span class="dot"></span>
          </button>`,
      }
    : false,
    scrollbar: isScrollbar && this.scrollbar ? 
      {
        el: this.scrollbar,
        dragSize: 95,
        draggable: true,
      }
    : false,
    on: {
      init: () => {
        if (!isLoop) this.updateNavigationButtons();
      },
      slideChange: () => {
        if (!isLoop) this.updateNavigationButtons();
      },
      autoplay: () => {
        if (!isLoop) this.updateNavigationButtons();
      },
    }
  };

  setTimeout(() => {
    this.swiper = new Swiper(this.slider, swiperOptions);
    if (!isLoop) this.updateNavigationButtons();
  }, 100);
};

CustomSlider.prototype.setupExternalNavigation = function () {
  if (this.nextBtn && this.prevBtn) {
    this.nextBtn.addEventListener('click', () => {
      if (this.swiper) this.swiper.slideNext();
    });

    this.prevBtn.addEventListener('click', () => {
      if (this.swiper) this.swiper.slidePrev();
    });
  }
};

customElements.define('custom-slider', CustomSlider);